import { Link } from "react-router-dom"
import type { BenefitDetailDto } from "@/lib/benefit-types"
import { fmtDate } from "@/lib/benefit-format"

export function HouseholdCopyNotice({ benefit }: { benefit: BenefitDetailDto }) {
  if (benefit.auditMetadataUnavailable) return <p role="status" className="rounded-md border p-3 text-sm text-muted-foreground">
    Audit metadata is unavailable; household-copy provenance could not be verified.
  </p>
  if (!benefit.householdCopiedFrom) return null
  return <p className="rounded-md border bg-muted/30 p-3 text-sm">
    Household carried forward from <Link className="underline" to={`/benefit-applications/${benefit.householdCopiedFrom.sourceApplicationId}`}>
      the application dated {fmtDate(benefit.householdCopiedFrom.sourceApplicationDate)}
    </Link>. Review it for this application. Previous income, grants and payments were not copied.
  </p>
}
